import { BooleanValueProperty } from './boolean-property.model';
import { TextProperty } from './text-property.model';

export class FormSectionProperties {
  public hideBorder: BooleanValueProperty;
  public hideTitle: BooleanValueProperty;
  public newPage: BooleanValueProperty;
  public pageNumbers: BooleanValueProperty;
  public sectionNumbers: BooleanValueProperty;
  public sectionTitle: BooleanValueProperty;
  public title: TextProperty;
  constructor(data: any = {}) {
    this.hideBorder = data.hideBorder || new BooleanValueProperty({ title: 'Hide border' }); // show / hide
    this.hideTitle = data.hideTitle || new BooleanValueProperty({ title: 'Hide title' }); // show / hide
    this.newPage = data.newPage || new BooleanValueProperty({ title: 'New page' }); // pdf force new page
    this.pageNumbers = data.pageNumbers || new BooleanValueProperty({ title: 'Page numbers' }); // show / hide
    this.sectionNumbers =
      data.sectionNumbers || new BooleanValueProperty({ title: 'Section numbers' }); // show / hide
    this.sectionTitle = data.sectionTitle || new TextProperty({ title: 'Section Title' }); // show / hide
    this.title = new TextProperty({
      title: 'Title',
      value: (data.title || {}).value || 'Untitled section',
    });
  }
}
